<template>
  <div class="main-statistical">
    <div class="main-statistical-pie">
      <PieScienceChart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        id="SciencePieChart"
        height="400px"
        width="50%"
        :PieScienceList="subjectList"
        seriesName="学科分布"
        v-loading="loading2"
      />
      <ThemeRiverChart
        style="-webkit-filter: saturate(0.5);filter: saturate(0.5);"
        height="400px"
        width="50%"
        :ThemList="ThemList"
        v-loading="loading1"
      />
    </div>
    <div class="research-lable" v-loading="loading">
      <span>
        研究聚焦
        <m-tips title="研究聚焦" content="研究聚焦展现了学者的研究关键词，体现学者研究演变情况。"></m-tips>
      </span>
      <el-select
        v-model="sort"
        placeholder="请选择"
        style="width: 200px;margin-left: 40px;"
        @change="selectType"
        :disabled="loading"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        ></el-option>
      </el-select>
      <el-select
        v-model="lang"
        placeholder="请选择"
        style="width: 200px;margin-left: 40px;"
        @change="selectLang"
        :disabled="loading"
      >
        <el-option v-for="item in langs" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>

    <div v-loading="loading">
      <el-timeline>
        <el-timeline-item
          :timestamp="item.year+''"
          placement="top"
          color=" rgba(0,147,221,.8)"
          v-for="(item,index) in research"
          :key="index"
          size="large"
        >
          <div v-for="(temp,i) in item.keywords" :key="i" class="timeline-card">
            <div>
              {{temp.key}}
              <p>{{temp[temp.transtype]}}</p>
            </div>
          </div>
        </el-timeline-item>
      </el-timeline>
    </div>
  </div>
</template>

<script>
import PieScienceChart from "@/components/Charts/PieScienceChart";
import ThemeRiverChart from "@/components/Charts/ThemeRiverChart";
import mTips from "@/components/m-tips/m-tips";
export default {
  name: "Menu2",
  components: {
    PieScienceChart,
    ThemeRiverChart,
    mTips
  },
  props: {
    loading: {
      type: Boolean
    },
    subjectList: {
      type: Array,
      required: true
    },
    ThemList: {
      type: Object,
      required: true
    },
    research: {
      type: Object,
      required: true
    }
  },
  watch: {
    subjectList: {
      deep: true,
      handler() {
        this.loading2 = false;
      }
    },
    ThemList: {
      deep: true,
      handler() {
        this.loading1 = false;
      }
    },
    loading: {
      deep: true,
      handler() {}
    }
  },
  data() {
    return {
      loading1: false,
      loading2: false,
      loading3: false,
      options: [
        {
          value: "选项1",
          label: "按时间降序"
        },
        {
          value: "选项2",
          label: "按时间升序"
        }
      ],
      langs: [
        {
          value: "all",
          label: "全部"
        },
        {
          value: "mix",
          label: "中英文互译"
        }
      ],
      sort: "选项1",
      lang: "all"
    };
  },
  methods: {
    selectType() {
      this.select();
    },
    select() {
      let data = {
        type: this.sort,
        lang: this.lang
      };
      this.$emit("select", data);
    },
    selectLang() {
      this.select();
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.subjectList.length) {
        this.loading2 = true;
      }
      if (!Object.keys(this.ThemList).length) {
        this.loading1 = true;
      }
    });
  }
};
</script>

<style lang="scss">
.main-statistical {
  padding: 0 40px;
  width: 100%;
  .main-statistical-pie {
    margin-top: 40px;
    width: 100%;
    display: flex;
    flex-direction: row;
    padding-bottom: 40px;
    border-bottom: 1.5px solid #888888;
  }
  .research-lable {
    display: flex;
    align-items: center;
  }
  .el-timeline-item__timestamp {
    font-size: 1.2em;
  }
  .el-timeline-item__content {
    font-size: 1.2em;
    width: 90%;
    max-height: 200px;
    display: flex;
    flex-wrap: wrap;
    overflow: hidden;
    .timeline-card {
      height: 100px;
      div {
        line-height: 25px;
        margin: 10px 0;
        margin-left: 40px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        padding: 15px;
        background: #f9f9f9;
        border: 3px solid #fff;
        -webkit-box-shadow: 1px 1px 1px #f2f2f2;
        box-shadow: 1px 1px 1px #f2f2f2;
        border-radius: 5%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/detail/Menu/menu2.vue